var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu circle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.13086,
    y: 0.633301,
    width: 14.8675,
    height: 14.8667,
    rx: 7.43333,
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.13086,
    y: 0.633301,
    width: 14.8675,
    height: 14.8667,
    rx: 7.43333,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7342 5.69482H5.39807C5.29903 5.69482 5.21875 5.7751 5.21875 5.87413C5.21875 5.97316 5.29903 6.05344 5.39807 6.05344H11.7342C11.8332 6.05344 11.9135 5.97316 11.9135 5.87413C11.9135 5.7751 11.8332 5.69482 11.7342 5.69482Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.637646
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7342 7.92651H5.39807C5.29903 7.92651 5.21875 8.00679 5.21875 8.10582C5.21875 8.20485 5.29903 8.28513 5.39807 8.28513H11.7342C11.8332 8.28513 11.9135 8.20485 11.9135 8.10582C11.9135 8.00679 11.8332 7.92651 11.7342 7.92651Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.637646
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7342 10.1584H5.39807C5.29903 10.1584 5.21875 10.2387 5.21875 10.3378C5.21875 10.4368 5.29903 10.5171 5.39807 10.5171H11.7342C11.8332 10.5171 11.9135 10.4368 11.9135 10.3378C11.9135 10.2387 11.8332 10.1584 11.7342 10.1584Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.637646
  })))));
};
export default SvgMenu;